import React from 'react'

export default function CommissionReceivables() {
  return (
    <div>
      CommissionReceivables
    </div>
  )
}
